import React, { useEffect, useState } from "react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import instagram from "../Assets/bottom_pic/xianhe_ig.png";
import facebook from "../Assets/bottom_pic/xianhe_fb.png";
import youtube from "../Assets/bottom_pic/xianhe_yt.png";
import google from "../Assets/bottom_pic/xianhe_gp.png";
import logo from "../Assets/bottom_pic/xianhe_footer_logo.png";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("language") || "en",
  );
  return (
    <div
      className="site-footer"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "30vh",
        backgroundColor: "#0a031e",
      }}
    >
      <div style={containerStyle}>
        <div style={footerSectionsStyle}>
          {/* Buttons Section */}
          <div style={logosectionStyle}>
            <img src={logo} alt="Logo" style={logoIconStyle} />
            <img src={google} alt="Google" style={logoIconStyle} />
            <div style={socialIconsContainerStyle}>
              <img src={facebook} alt="Facebook" style={socialIconStyle} />
              <a
                href="https://www.instagram.com/xianhefairylotus/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" style={socialIconStyle} />
              </a>
              <img src={youtube} alt="YouTube" style={socialIconStyle} />
            </div>
          </div>

          {/* About us Section */}
          <div style={sectionStyle}>
            <div style={sectionInsideStyle}>
              <h3 style={sectionHeaderStyle}>{t("footer.about")}</h3>
              <Link to="/about" style={linkStyle}>
                {t("footer.aboutUs")}
              </Link>
              <Link to="/newsroom" style={linkStyle}>
                {t("footer.newsroom")}
              </Link>
              <Link to="/blank" style={linkStyle}>
                {t("footer.newsletter")}
              </Link>
              <Link to="/contact" style={linkStyle}>
                {t("footer.contactUs")}
              </Link>
              {/* <button style={{color: "#DFBD69",textDecoration: 'none',marginBottom: '10px',fontSize: '14px',backgroundColor: "transparent", border:'none'}} 
            onClick={() => window.open("https://xianhefairy.com/download/XianheMobileVer7.apk", "_blank")}>
              Download XianHe Mobile
          </button> */}
            </div>
          </div>

          {/* Discover Section */}
          <div style={sectionStyle}>
            <div style={sectionInsideStyle}>
              <h3 style={sectionHeaderStyle}>{t("footer.discover")}</h3>

              <Link to="/shop" style={linkStyle}>
                {t("footer.ourShop")}
              </Link>
              <Link to="/courses" style={linkStyle}>
                {t("footer.ourCourses")}
              </Link>
              <Link to="/pricing" style={linkStyle}>
                {t("footer.planPricing")}
              </Link>
              <Link to="/faqs" style={linkStyle}>
                {t("footer.helpSupport")}
              </Link>
            </div>
          </div>

          {/* Terms & Policies Section */}
          <div style={sectionStyle}>
            <div style={sectionInsideStyle}>
              <h3 style={sectionHeaderStyle}>{t("footer.termsPolicies")}</h3>
              <Link to="/returnpolicy" style={linkStyle}>
                {t("footer.returnsRefunds")}
              </Link>
              <Link to="/terms-conditions" style={linkStyle}>
                {t("footer.termsConditions")}
              </Link>
              <Link to="/deliveryinfo" style={linkStyle}>
                {t("footer.deliveryInformation")}
              </Link>
              <Link to="/privacyinfo" style={linkStyle}>
                {t("footer.privacyInformation")}
              </Link>
            </div>
          </div>
        </div>
        <hr style={dividerStyle} />
        <p style={footerTextStyle}>
          ©2024 XIANHE PTE LTD. ALL RIGHTS RESERVED.
        </p>
      </div>
    </div>
  );
};
const containerStyle = {
  backgroundColor: "#0a031e",
  padding: "24px 20px",
  textAlign: "center",
  fontFamily: "Arial, sans-serif",
  position: "relative",
  flex: 1,
  zIndex: 9000, // High z-index to ensure it stays on top of AccountInfoPanel
  marginTop: "auto", // Push the footer to the bottom of the page
  alignItems: "center",
  justifyContent: "center",
};

const footerSectionsStyle = {
  display: "flex",
  justifyContent: "center",
  // alignItems: 'center',
  flexWrap: "wrap",
  gap: "16px",
  width: "80%",
  margin: "0 auto",
};

const sectionStyle = {
  flex: "1",
  minWidth: "100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "left",
  // backgroundColor:"yellow",
};

const logosectionStyle = {
  flex: "1",
  minWidth: "200px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

const sectionHeaderStyle = {
  fontSize: "20px",
  marginBottom: "8px",
  fontWeight: "bold",
  color: "rgba(255,255,255,0.8)",
};

const linkStyle = {
  color: "rgba(255,255,255,0.8)",
  textDecoration: "none",
  marginBottom: "4px",
  fontSize: "14px",
};

const socialIconsContainerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
  marginTop: "8px",
};

const socialIconStyle = {
  fontSize: "24px",
  cursor: "pointer",
  transition: "color 0.3s ease",
  color: "#DFBD69",
};

const sectionInsideStyle = {
  flex: "1",
  minWidth: "100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  textAlign: "left",
};

const logoIconStyle = {
  fontSize: "24px",
  cursor: "pointer",
  transition: "color 0.3s ease",
  color: "#DFBD69",
  marginBottom: "15px",
};

const dividerStyle = {
  border: "none",
  borderTop: "1px solid rgba(255,255,255,0.2)",
  width: "70%",
  margin: "4% auto 0",
};

const footerTextStyle = {
  marginTop: "16px",
  fontSize: "12px",
  color: "rgba(255,255,255,0.8)",
  fontFamily: "Roboto, Arial, sans-serif",
};

export default Footer;
